<template>
  <div class="link-item">
    <div class="d-flex justify-content-between flex-row">
      <div class="d-flex flex-column select-link-project">
        <label class="visible-xs">
          <div class="d-flex align-items-center text-light flex-row">
            <img
              :src="INTEGRATION_LOGO_URLS[integrationType]"
              class="mr-10"
              width="15"
              height="15"
              alt="Integration logo"
            />
            <strong> {{ integrationDisplayName }} {{ projectLabel }} </strong>
          </div>
        </label>
        <AppSelect
          v-model="selectedRemote"
          :options="availableRemoteOptions()"
          :select2-options="select2Options"
        />
      </div>
      <div class="d-flex flex-column align-self-center linked_to">
        <img
          :src="linkIcon"
          alt="New project icon"
          width="16"
          height="16"
        />
      </div>
      <div class="d-flex flex-column select-link-project">
        <label class="visible-xs">
          <div class="d-flex align-items-center text-light flex-row">
            <img
              :src="HUBSTAFF_LOGO"
              class="mr-10"
              width="15"
              height="15"
              alt="Hubstaff logo"
            />
            <strong> Hubstaff project </strong>
          </div>
        </label>
        <AppSelect
          v-model="selectedLocal"
          :options="availableLocalOptions()"
          :select2-options="select2Options"
        />
      </div>
      <div class="remove-item d-flex flex-column align-self-center">
        <span
          v-if="isRemovable"
          v-tooltip
          :title="'Delete row'"
          class="cursor-pointer"
          @click="remove"
        >
          <i class="hi hi-close hi-12 text-danger" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import { INTEGRATION_LOGO_URLS, HUBSTAFF_LOGO, ICON_PLUS, ICON_CONNECT, ICON_DISCONNECT } from '~/rails_assets';
import { createPersist } from '../../utils/persist';

const localStore = createPersist('integration-wizard');

export default {
  name: 'IntegrationWizardLinkItem',
  props: {
    show: Boolean,
    localProjects: Array,
    remoteProjects: Array,
    selected: Object,
    isRemovable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const store = localStore.get('integrationWizardState');

    return {
      ICON_PLUS,
      ICON_CONNECT,
      ICON_DISCONNECT,
      HUBSTAFF_LOGO,
      INTEGRATION_LOGO_URLS,
      integrationDisplayName: store.integration_display_name,
      integrationType: store.integration_type,
      projectLabel: store.labels.project,
      select2Options: {
        allowClear: true,
        multiple: false,
        placeholder: 'Select project',
        width: '100%',
      },
    };
  },
  computed: {
    linkIcon() {
      return this.selectedRemote && this.selectedLocal && this.selectedLocal !== -1 ? ICON_CONNECT : ICON_DISCONNECT;
    },
    selectedRemote: {
      get() {
        return this.selected.remote_id;
      },
      set(newRemoteId) {
        if (
          this.integrationWizardState().selectedProjects !== undefined &&
          this.selected.local_id !== null &&
          this.selected.local_id !== undefined
        ) {
          const index = this.integrationWizardState().selectedProjects.remote.indexOf(
            (this.selected.remote_id || '-1').toString(),
          );

          this.removeSelection('remote', index);
        }

        let remoteId = null;
        let remoteName = null;
        const project = this.remoteProjects.find((p) => p.remote_id === newRemoteId);

        if (project) {
          remoteId = project.remote_id;
          remoteName = project.remote_name;
        }

        this.selected.remote_id = remoteId;
        this.selected.remote_name = remoteName;
        this.setStatus();
        this.$emit('check', this.selected.local_id, this.selected.remote_id);
      },
    },
    selectedLocal: {
      get() {
        if (this.selected.remote_id) {
          return this.selected.local_id || -1;
        }

        return null;
      },
      set(newLocalId) {
        if (
          this.integrationWizardState().selectedProjects !== undefined &&
          this.selected.local_id != null &&
          this.selected.local_id !== undefined
        ) {
          const index = this.integrationWizardState().selectedProjects.local.indexOf(this.selected.local_id.toString());

          this.removeSelection('local', index);
        }

        let localId = null;
        let localName = null;

        if (newLocalId && parseInt(newLocalId) !== -1) {
          const localProject = this.localProjects.find((p) => p.local_id === parseInt(newLocalId));

          localId = newLocalId;
          localName = localProject.local_name;
        }
        this.selected.local_id = localId;
        this.selected.local_name = localName;

        this.setStatus();
        this.$emit('check', this.selected.local_id, this.selected.remote_id);
      },
    },
  },
  methods: {
    availableLocalOptions() {
      const localOptions = [];

      localOptions.push({ id: -1, text: '+ Create new project', new: true });
      this.localProjects.forEach((p) => {
        if (
          parseInt(this.selected.local_id) === p.local_id ||
          !this.integrationWizardState().selectedProjects.local.includes(p.local_id.toString())
        ) {
          localOptions.push({
            id: p.local_id,
            text: p.local_name,
          });
        }
      });

      return localOptions;
    },
    availableRemoteOptions() {
      const remoteOptions = this.remoteProjects
        .map((p) => {
          // It is important to keep projects with null or undefined remote ID so that the user has feedback in case there are some information missing
          if (
            p.remote_id == null ||
            this.selected.remote_id === p.remote_id ||
            !this.integrationWizardState().selectedProjects.remote.includes(p.remote_id.toString())
          ) {
            const option = {
              id: p.remote_id,
              text: p.remote_name,
            };

            if (p.remote_id == null) {
              Object.assign(option, {
                error: true,
                disabled: true,
                disabledHint: "There was a problem fetching this project's information",
              });
            }

            return option;
          }

          return null;
        })
        .filter(Boolean);

      return remoteOptions;
    },
    integrationWizardState() {
      return localStore.get('integrationWizardState');
    },
    removeSelection(projectSource, index) {
      const store = this.integrationWizardState();

      if (store) {
        store.selectedProjects[projectSource].splice(index, 1);
        localStore.set('integrationWizardState', store);
      }
    },
    remove() {
      this.$emit('remove', this.selected);
    },
    setStatus() {
      if (!this.selected.local_id || this.selected.local_id === -1) {
        this.selected.status = 'unlinked';
      } else {
        this.selected.status = 'matched';
      }
    },
  },
};
/* eslint-enable vue/no-mutating-props */
</script>
